/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { BEResponseWorkflowResponse, WorkflowEvent } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Modifica un fornitore
 * @summary Modifica un fornitore
 */
export const postBackAzioniContabilitaModificaFornitore = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/contabilita/modificaFornitore`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniContabilitaModificaFornitoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaModificaFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniContabilitaModificaFornitore>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniContabilitaModificaFornitore>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniContabilitaModificaFornitore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniContabilitaModificaFornitoreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniContabilitaModificaFornitore>>
  >;
export type PostBackAzioniContabilitaModificaFornitoreMutationBody =
  WorkflowEvent;
export type PostBackAzioniContabilitaModificaFornitoreMutationError =
  ErrorType<unknown>;

/**
 * @summary Modifica un fornitore
 */
export const usePostBackAzioniContabilitaModificaFornitore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaModificaFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniContabilitaModificaFornitoreMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Verifica se il fornitore è già presente in archivio
 * @summary Verifica esistenza fornitore
 */
export const postBackAzioniContabilitaEsisteFornitore = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/contabilita/esisteFornitore`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniContabilitaEsisteFornitoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaEsisteFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniContabilitaEsisteFornitore>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniContabilitaEsisteFornitore>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniContabilitaEsisteFornitore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniContabilitaEsisteFornitoreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postBackAzioniContabilitaEsisteFornitore>>
  >;
export type PostBackAzioniContabilitaEsisteFornitoreMutationBody =
  WorkflowEvent;
export type PostBackAzioniContabilitaEsisteFornitoreMutationError =
  ErrorType<unknown>;

/**
 * @summary Verifica esistenza fornitore
 */
export const usePostBackAzioniContabilitaEsisteFornitore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaEsisteFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniContabilitaEsisteFornitoreMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea un impegno di spesa
 * @summary Crea un impegno
 */
export const postBackAzioniContabilitaCreaImpegno = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/contabilita/creaImpegno`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniContabilitaCreaImpegnoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaImpegno>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniContabilitaCreaImpegno>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaImpegno>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniContabilitaCreaImpegno(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniContabilitaCreaImpegnoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniContabilitaCreaImpegno>>
>;
export type PostBackAzioniContabilitaCreaImpegnoMutationBody = WorkflowEvent;
export type PostBackAzioniContabilitaCreaImpegnoMutationError =
  ErrorType<unknown>;

/**
 * @summary Crea un impegno
 */
export const usePostBackAzioniContabilitaCreaImpegno = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaImpegno>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniContabilitaCreaImpegnoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Inserisce un fornitore
 * @summary Inserisce un fornitore
 */
export const postBackAzioniContabilitaCreaFornitore = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-bo-procedimenti/azioni/contabilita/creaFornitore`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostBackAzioniContabilitaCreaFornitoreMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackAzioniContabilitaCreaFornitore>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaFornitore>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postBackAzioniContabilitaCreaFornitore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackAzioniContabilitaCreaFornitoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackAzioniContabilitaCreaFornitore>>
>;
export type PostBackAzioniContabilitaCreaFornitoreMutationBody = WorkflowEvent;
export type PostBackAzioniContabilitaCreaFornitoreMutationError =
  ErrorType<unknown>;

/**
 * @summary Inserisce un fornitore
 */
export const usePostBackAzioniContabilitaCreaFornitore = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackAzioniContabilitaCreaFornitore>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackAzioniContabilitaCreaFornitoreMutationOptions(options);

  return useMutation(mutationOptions);
};
